class Utils {
  static DEFAULT_INPUT_DATE_FORMAT = "yyyy-MM-ddTHH:mm:ss";
  static DEFAULT_OUTPUT_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";

  static formattedUtcDate(date = new Date(), format = this.DEFAULT_INPUT_DATE_FORMAT) {
    const formattedUTCDate = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      hour12: false,
      timeZone: 'UTC',
    }).format(date);

    const dateComponents = formattedUTCDate.match(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}:\d{2}:\d{2})/);
    const [, month, day, year, time] = dateComponents;
    let formattedDate = format;
    formattedDate = formattedDate.replace("yyyy", year);
    formattedDate = formattedDate.replace("MM", month);
    formattedDate = formattedDate.replace("dd", day);
    formattedDate = formattedDate.replace("HH:mm:ss", time);
    formattedDate = formattedDate.replace("T", "T");
    return formattedDate;
  }

  static simplifyDate(
    dateString,
    outputFormat = this.DEFAULT_OUTPUT_DATE_FORMAT,
    inputFormat = this.DEFAULT_INPUT_DATE_FORMAT,
  ) {
    const parseFormat = (dateStr, fmt) => {
      const parts = dateStr.match(/(\d+)/g);
      const getDatePart = (key) => {
        const index = fmt.split(" ").join("").split(/[-:T]/).findIndex((part) => part === key);
        return index !== -1 ? parseInt(parts[index], 10) : null;
      };

      const dateObj = {
        year: getDatePart('yyyy'),
        month: getDatePart('MM') ? getDatePart('MM') - 1 : 0,
        day: getDatePart('dd') || 1,
        hour: getDatePart('HH') || 0,
        minute: getDatePart('mm') || 0,
        second: getDatePart('ss') || 0,
      };

      return new Date(Date.UTC(dateObj.year, dateObj.month, dateObj.day, dateObj.hour, dateObj.minute, dateObj.second));
    };

    const formatDate = (date, format) => {
      const pad = (n) => (n < 10 ? "0" + n : n);
      const replacements = {
        yyyy: date.getFullYear(),
        MM: pad(date.getMonth() + 1),
        dd: pad(date.getDate()),
        HH: pad(date.getHours()),
        mm: pad(date.getMinutes()),
        ss: pad(date.getSeconds()),
      };
      return format.replace(/(yyyy|MM|dd|HH|mm|ss)/g, (matched) => replacements[matched]);
    };

    const date = parseFormat(dateString, inputFormat);
    const now = new Date();
    const isToday = date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();
    if (isToday) {
      return formatDate(date, 'HH:mm:ss');
    }

    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const isYesterday = date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
    if (isYesterday) {
      return 'Yesterday ' + formatDate(date, 'HH:mm:ss');
    }
    return formatDate(date, outputFormat);
  }

  static URL_REGEX = /^(https?:\/\/[^/]+).*$/;

  static getUrl(str) {
    const match = this.URL_REGEX.exec(str);
    return match ? match[1] : null;
  }

  static truncate(input, len) {
    let line = input;
    if (input.length > len) {
      line = input.substring(0, len) + "...";
    }
    return line.replace(/\n/g, " ");
  }

  static async sha256(str) {
    const buffer = new TextEncoder("utf-8").encode(str);
    const hash = await crypto.subtle.digest("SHA-256", buffer);
    return Array.from(new Uint8Array(hash)).map((b) => b.toString(16).padStart(2, "0")).join("");
  }

  // TODO: inform user about Firebox config
  // TODO: Firebox image support
  // TODO: IE/Edge support
  static async getClipboardContent() {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not available');
    }

    try {
      const text = await navigator.clipboard.readText();
      if (text) {
        return { type: 'Text', value: text };
      }

      const clipboardItems = await navigator.clipboard.read();
      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type.startsWith("image/")) {
            const blob = await clipboardItem.getType(type);
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve({ type: 'Image', value: reader.result });
              };
              reader.readAsDataURL(blob);
            });
          }
        }
      }
    } catch (err) {
      throw new Error('Failed to read clipboard contents: ' + err);
    }

    throw new Error('No text or image data found on the clipboard');
  }
}

export default Utils;
